<template>
  <div class="sdk">
    <sdk nameEn="android-voice-compress-sdk"></sdk>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import sdk from '@/components/common/sdk.vue';
export default {
  inject: ['reload'],
    metaInfo: {
    title: 'Android语音压缩SDK',
    meta: [
      {
        name: 'keywords',
        content: '北斗语音压缩sdk,北斗安卓语音压缩sdk,北斗短报文语音压缩sdk',
      },
      {
        name: 'description',
        content:
          '北斗语音压缩sdk、北斗语音解压sdk、北斗语音分包sdk、短报文语音压缩sdk、短报文语音分包sdk',
      },
    ],
  },
  components: {
    sdk,
  },
  methods: {
    ...mapActions(['setBg']),
  },
  watch: {
    $route: function (newVal, oldVal) {
      // 路由变化展示新文件
      console.log({ newVal, oldVal });
      if (newVal.name !== oldVal.name) {
        this.reload();
      }
    },
  },
  created() {
    this.setBg(this.$route.meta.showBg);
  },
};
</script>

<style lang="scss" scoped>
</style>